module.exports = __webpack_public_path__ + "img/bg_workcard.29853f4b.png";